import { FunctionComponent, PropsWithChildren } from 'react';

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';

import { setRadioGroupCheckedValue } from '../../../../utils/set-radio-group-checked-value/set-radio-group-checked-value.util';
import { BasicInfoFormikModel } from '../../models/basic-info-formik.model';
import { BasicInfoComponentProps } from '../../types/basic-info-component.props';
import { ServerInitiatedTypeEnum } from './enum/server-intiated-type.enum';
import { serverInitiatedTypes } from './utils/server-initiated-types.util';

export const ServerInitiatedTypeRadioGroupInput: FunctionComponent<
  BasicInfoComponentProps
> = (props: PropsWithChildren<BasicInfoComponentProps>) => {
  const { values, setFieldValue, handleBlur } = props;

  const setCheckedValue = setRadioGroupCheckedValue<BasicInfoFormikModel>(
    setFieldValue,
    'serverInitiatedType'
  );

  return (
    <FormControl
      data-testid="server-initiated-type-form-input-form-control"
      className="not-centered radio-button-control"
    >
      <FormLabel
        id="server-initiated-type"
        sx={{ color: theme => theme.palette.black.main }}
        required={true}
        classes={{ focused: 'label-focused' }}
      >
        Server Initiated
      </FormLabel>

      <RadioGroup
        row
        aria-labelledby="server-initiated-type"
        name="serverIntitiatedType"
        value={values.serverInitiatedType ?? ServerInitiatedTypeEnum.NONE}
        onChange={setCheckedValue}
        onBlur={handleBlur}
      >
        {serverInitiatedTypes.map(option => (
          <FormControlLabel
            className="radio-button-label"
            key={option.value}
            value={option.value}
            label={option.label}
            control={
              <Radio
                classes={{
                  root: 'radio-button-container',
                }}
                className="radio-button"
                data-testid={`${option.label}-option`}
                checked={values.serverInitiatedType === option.value}
              />
            }
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
